import { NoBlending, ShaderMaterial, Uniform } from "three";

import fragmentShaderSource from "./glsl/HueSaturation.frag";
import vertexShader from "./glsl/Common.vert";
import blendFunctions from "./glsl/BlendFunctions.frag";
import blendMode from "./glsl/BlendMode.frag";

/**
 * A simple copy shader material.
 */

export class HueSaturationMaterial extends ShaderMaterial {

    constructor(defines = {}) {
        let fragmentShader = fragmentShaderSource.replace("BLEND_FUNCTIONS;", blendFunctions);
        fragmentShader = fragmentShader.replace("BLEND_MODE;", blendMode);

        super({
            name: "HueSaturationMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0),
                blendID: new Uniform(0),

                hueReds: new Uniform(0),
                hueYellows: new Uniform(0),
                hueGreens: new Uniform(0),
                hueCyans: new Uniform(0),
                hueBlues: new Uniform(0),
                hueMagentas: new Uniform(0),

                lumReds: new Uniform(0),
                lumYellows: new Uniform(0),
                lumGreens: new Uniform(0),
                lumCyans: new Uniform(0),
                lumBlues: new Uniform(0),
                lumMagentas: new Uniform(0),

                satReds: new Uniform(0),
                satYellows: new Uniform(0),
                satGreens: new Uniform(0),
                satCyans: new Uniform(0),
                satBlues: new Uniform(0),
                satMagentas: new Uniform(0),

                rangeDegree: new Uniform(defines.RANGE_DEGREE || 12.0),
                baseWeightsRed: new Uniform(defines.BASE_WEIGHTS_RED || 0.0)
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });
    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
